<template>
  <div class="header-spacer" :style="{ height: spacerHeight + 'px' }"></div>
  <header class="party-header" :class="[{ scrolled: isScrolled }, theme]" ref="headerEl">

    <div class="top-bars">
      <div class="bismillah-bar">
        <span class="bismillah-text">بِسْمِ اللَّهِ الرَّحْمَنِ الرَّحِيمِ</span>
      </div>
      <div class="quran-bar">
        <div class="quran-verses">
          <div class="quran-row">
            <p class="quran-verse">أَفَمَنِ اتَّبَعَ رِضْوَانَ اللَّهِ كَمَنْ بَاءَ بِسَخَطٍ مِّنَ اللَّهِ وَمَأْوَاهُ جَهَنَّمُ ۚ وَبِئْسَ الْمَصِيرُ</p>
            <span class="quran-divider">۞</span>
            <p class="quran-verse">قُلِ اللَّهُمَّ مَالِكَ الْمُلْكِ تُؤْتِي الْمُلْكَ مَن تَشَاءُ وَتَنزِعُ الْمُلْكَ مِمَّن تَشَاءُ وَتُعِزُّ مَن تَشَاءُ وَتُذِلُّ مَن تَشَاءُ ۖ بِيَدِكَ الْخَيْرُ ۖ إِنَّكَ عَلَىٰ كُلِّ شَيْءٍ قَدِيرٌ</p>
          </div>
          <p class="quran-meaning">যে ব্যক্তি আল্লাহর সন্তুষ্টির অনুসরণ করে সে কি তার মতো, যে আল্লাহর ক্রোধের পাত্র হয়েছে? ৷ বলুন, হে আল্লাহ! তুমিই রাজ্যের মালিক। তুমি যাকে ইচ্ছা রাজ্য দান করো এবং যার কাছ থেকে ইচ্ছা রাজ্য ছিনিয়ে নাও; যাকে ইচ্ছা সম্মান দান করো এবং যাকে ইচ্ছা অপমানিত করো। কল্যাণ তোমারই হাতে। নিশ্চয়ই তুমি সর্বশক্তিমান।</p>
          <span class="quran-ref">সূরা আল ইমরান — আয়াত ২৫-২৬</span>
        </div>
      </div>
      <div class="main-header">
        <div class="container">
          <div class="header-inner">
            <div class="logo-zone">
              <div class="logo-circle">
                <img v-if="hasLogo" :src="`${urlBase}/${systemSettings.logo}`" :alt="systemSettings.brand_name" class="logo-img" @error="handleLogoError" />
                <img v-else src="@/assets/files/party/flag.png" :alt="systemSettings.brand_name" class="logo-img" @error="handleLogoError" />
              </div>
            </div>
            <div class="party-name-center">
              <h1 class="party-name-bn">{{ systemSettings.brand_name || 'বাংলাদেশ আজাদ পার্টি' }}</h1>
              <p class="party-name-en">{{ systemSettings.tagline || 'জান দিবো · জুলাই দিবো না' }}</p>
            </div>
            <div class="symbol-zone">
              <div class="symbol-box">
                <img 
                  v-if="hasSymbol"
                  :src="`${urlBase}/${systemSettings.party_symbol}`"
                  alt="নির্বাচনী প্রতীক"
                  class="symbol-img"
                  @error="handleSymbolError"
                />
                <ElectionSymbolSvg v-else />
              </div>
              <span class="symbol-label">নির্বাচনী প্রতীক</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <nav class="nav-bar">
      <div class="container">
        <div class="nav-inner">
          <div class="nav-links">
            <router-link to="/" class="nav-link">হোম</router-link>
            <span class="nav-sep"></span>
            <router-link to="/principles" class="nav-link">নীতি ও আদর্শ </router-link>
            <span class="nav-sep"></span>
            <router-link to="/the-seventeen-points" class="nav-link">১৭ দফা</router-link>
            <span class="nav-sep"></span>
            <router-link to="/azad-barta" class="nav-link">আজাদ বার্তা </router-link>
            <span class="nav-sep"></span>
            <router-link to="/opinions" class="nav-link">জনতার মতামত </router-link>
            <span class="nav-sep"></span>
            <router-link to="/july-fighters" class="nav-link">জুলাই যোদ্ধা তালিকা (শহীদ ও আহত)</router-link>
            <span class="nav-sep"></span>
            <router-link to="/faq" class="nav-link">জিজ্ঞাসা </router-link>
            <span class="nav-sep"></span>
            <router-link to="/contact" class="nav-link">যোগাযোগ</router-link>
          </div>
          <div class="nav-actions">
            <button class="theme-toggle" @click="toggleTheme" :title="theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'">
                <span v-if="theme === 'dark'">☀️</span>
                <span v-else>🌙</span>
              </button>
            <router-link to="/membership" class="cta-button">সদস্য হন</router-link>
            <button class="mobile-toggle" @click="toggleMenu" aria-label="Toggle menu">
              <span :class="['hamburger', { active: menuOpen }]"></span>
            </button>
          </div>
        </div>
        <transition name="slide-down">
          <div v-if="menuOpen" class="mobile-nav">
            <router-link to="/" class="mobile-link" @click="closeMenu">হোম</router-link>
            <router-link to="/vision" class="mobile-link" @click="closeMenu">নীতি ও আদর্শ</router-link>
            <router-link to="/the-seventeen-points" class="mobile-link" @click="closeMenu">১৭ দফা</router-link>
            <router-link to="/azad-barta" class="mobile-link" @click="closeMenu">আজাদ বার্তা </router-link>
            <router-link to="/opinions" class="mobile-link" @click="closeMenu">জনতার মতামত </router-link>
            <router-link to="/july-fighters" class="mobile-link" @click="closeMenu">জুলাই যোদ্ধা তালিকা (শহীদ ও আহত) </router-link>
            <router-link to="/faq" class="mobile-link" @click="closeMenu">জিজ্ঞাসা</router-link>
            <router-link to="/contact" class="mobile-link" @click="closeMenu">যোগাযোগ</router-link>
            <button class="mobile-cta" @click="openModalFromMobile">সদস্য হন</button>
          </div>
        </transition>
      </div>
    </nav>

    <AppointmentModal v-model="appointmentModalOpen" />
  </header>
</template>

<script setup>
import { ref, computed, inject, onMounted, onUnmounted, nextTick } from 'vue';
import axios from 'axios';
import AppointmentModal from '../../components/AppointmentModal.vue';

// ─── Theme (provided by parent layout) ───
const theme = inject('theme', ref('dark'));
const toggleTheme = inject('toggleTheme', () => {});

const ElectionSymbolSvg = {
  template: `
    <svg width="36" height="36" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M22 4 L25 13 L28 8 L25 19 L34 14 L29 22 L38 22 L29 28 L36 34 L27 30 L28 40 L22 33 L16 40 L17 30 L8 34 L15 28 L6 22 L15 22 L10 14 L19 19 L16 8 L19 13 Z" fill="#C8102E" opacity="0.85"/>
      <circle cx="22" cy="22" r="8" fill="#f0d080"/>
      <circle cx="22" cy="22" r="5" fill="#C8102E"/>
      <circle cx="22" cy="22" r="2.5" fill="#f0d080"/>
    </svg>`
};

const apiBase  = ref(process.env.VUE_APP_BASE_API);
const urlBase  = ref(process.env.VUE_APP_BASE_URL);

const menuOpen             = ref(false);
const appointmentModalOpen = ref(false);
const isScrolled           = ref(false);
const headerEl             = ref(null);
const spacerHeight         = ref(0);

const systemSettings = ref({
  brand_name: '', logo: '', phone: '',
  facebook: '', twitter: '', instagram: '', linkedin: '',
});

const hasLogo = computed(() => {
  const logo = systemSettings.value.logo;
  return logo && logo.trim() !== '';
});

let lastScrollY = 0;
let ticking = false;

const handleScroll = () => {
  lastScrollY = window.scrollY;
  if (!ticking) {
    requestAnimationFrame(() => {
      if (!isScrolled.value && lastScrollY > 100) {
        isScrolled.value = true;
      } else if (isScrolled.value && lastScrollY < 20) {
        isScrolled.value = false;
      }
      ticking = false;
    });
    ticking = true;
  }
};

const updateSpacer = () => {
  if (headerEl.value) {
    spacerHeight.value = headerEl.value.offsetHeight;
  }
};

const hasSymbol = computed(() => {
  const symbol = systemSettings.value.party_symbol;
  return symbol && symbol.trim() !== '';
});

const handleSymbolError = (event) => {
  event.target.style.display = 'none';
};

const loadSystemSettings = async () => {
  try {
    const response = await axios.get(`${apiBase.value}/system`);
    if (response.data?.system) systemSettings.value = response.data.system;
  } catch (error) {
    console.error('Failed to load system settings:', error);
  }
};

const toggleMenu = () => {
  menuOpen.value = !menuOpen.value;
  document.body.style.overflow = menuOpen.value ? 'hidden' : '';
};

const closeMenu = () => {
  menuOpen.value = false;
  document.body.style.overflow = '';
};

const openModalFromMobile = () => {
  closeMenu();
  setTimeout(() => { appointmentModalOpen.value = true; }, 200);
};

const handleLogoError = (event) => {
  event.target.style.display = 'none';
};

onMounted(async () => {
  loadSystemSettings();
  await nextTick();
  updateSpacer();
  window.addEventListener('scroll', handleScroll, { passive: true });
  window.addEventListener('resize', updateSpacer);
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
  window.removeEventListener('resize', updateSpacer);
});
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Amiri:wght@400;700&family=Noto+Sans+Bengali:wght@400;600;700&display=swap');

/* ─── CSS Variables: Dark (default) ─── */
.party-header {
  --header-bg:         #161616;
  --header-bg-nav:     #0a0a0a;
  --header-bg-mobile:  #141414;
  --header-border:     rgba(255, 255, 255, 0.05);
  --header-text:       rgba(255, 255, 255, 0.75);
  --header-text-hover: #ffffff;
  --header-gold:       #f0d080;
  --header-gold-muted: rgba(200, 168, 75, 0.75);
  --header-gold-dim:   rgba(200, 168, 75, 0.55);
  --header-gold-faint: rgba(200, 168, 75, 0.06);
  --header-sep:        rgba(255, 255, 255, 0.08);
  --header-verse:      #c8a84b;
  --bismillah-shadow:  rgba(240, 208, 128, 0.35);
  --logo-shadow:       rgba(200, 16, 46, 0.3);
  --symbol-bg:         #0a2a14;
  --symbol-shadow:     rgba(0, 107, 63, 0.3);
  --mobile-link-hover-bg: rgba(200, 168, 75, 0.06);
  --theme-toggle-bg:   rgba(255, 255, 255, 0.08);
  --theme-toggle-border: rgba(255, 255, 255, 0.15);
}

/* ─── CSS Variables: Light ─── */
.party-header.light {
  --header-bg:         #f5f0e8;
  --header-bg-nav:     #ede8dc;
  --header-bg-mobile:  #ece7db;
  --header-border:     rgba(0, 0, 0, 0.08);
  --header-text:       rgba(40, 30, 20, 0.8);
  --header-text-hover: #1a1008;
  --header-gold:       #8a6a10;
  --header-gold-muted: rgba(120, 90, 20, 0.85);
  --header-gold-dim:   rgba(120, 90, 20, 0.55);
  --header-gold-faint: rgba(120, 90, 20, 0.06);
  --header-sep:        rgba(0, 0, 0, 0.1);
  --header-verse:      #7a5c18;
  --bismillah-shadow:  rgba(120, 90, 20, 0.2);
  --logo-shadow:       rgba(200, 16, 46, 0.2);
  --symbol-bg:         #d8edd8;
  --symbol-shadow:     rgba(0, 107, 63, 0.15);
  --mobile-link-hover-bg: rgba(120, 90, 20, 0.07);
  --theme-toggle-bg:   rgba(0, 0, 0, 0.06);
  --theme-toggle-border: rgba(0, 0, 0, 0.15);
}

/* ─── Base ─── */
.party-header {
  font-family: 'Noto Sans Bengali', sans-serif;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  width: 100%;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

/* ─── Top bars wrapper ─── */
.top-bars {
  transition: opacity 0.25s ease;
}

.party-header.scrolled {
  transform: translateY(calc(-100% + 44px));
}

.party-header.scrolled .top-bars {
  opacity: 0;
  pointer-events: none;
}

/* ─── Bismillah Bar ─── */
.bismillah-bar {
  background: var(--header-bg);
  text-align: center;
  padding: 5px 20px;
  transition: background 0.3s ease;
}

.bismillah-text {
  font-family: 'Amiri', serif;
  font-size: 16px;
  color: var(--header-gold);
  letter-spacing: 3px;
  text-shadow: 0 0 20px var(--bismillah-shadow);
  transition: color 0.3s ease;
}

/* ─── Quran Bar ─── */
.quran-bar {
  background: var(--header-bg);
  padding: 6px 20px 5px;
  display: flex;
  justify-content: center;
  transition: background 0.3s ease;
}

.quran-verses {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  max-width: 1000px;
  width: 100%;
}

.quran-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  direction: rtl;
  width: 100%;
}

.quran-verse {
  font-family: 'Amiri', serif;
  font-size: 11px;
  color: var(--header-verse);
  direction: rtl;
  line-height: 1.7;
  margin: 0;
  text-align: center;
  transition: color 0.3s ease;
  flex: 0 1 auto;
}

.quran-divider {
  font-family: 'Amiri', serif;
  font-size: 14px;
  color: var(--header-gold-dim);
  flex-shrink: 0;
  line-height: 1;
}

.quran-meaning {
  font-family: 'Noto Sans Bengali', sans-serif;
  font-size: 10px;
  color: var(--header-gold-dim);
  direction: ltr;
  line-height: 1.6;
  margin: 1px 0 0;
  text-align: center;
  transition: color 0.3s ease;
}

.quran-ref {
  font-family: Georgia, serif;
  font-size: 10px;
  color: var(--header-gold-dim);
  letter-spacing: 1.5px;
  margin-top: 2px;
  transition: color 0.3s ease;
}

/* ─── Main Header ─── */
.main-header {
  background: var(--header-bg);
  border-bottom: 3px solid #C8102E;
  transition: background 0.3s ease;
}

.header-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
  gap: 16px;
}

/* ─── Logo ─── */
.logo-circle {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  border: 2px solid #C8102E;
  overflow: hidden;
  box-shadow: 0 0 16px var(--logo-shadow);
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: box-shadow 0.3s ease;
}

.logo-img { width: 100%; height: 100%; object-fit: contain; }

/* ─── Party Name ─── */
.party-name-center { flex: 1; text-align: center; }

.party-name-bn {
  font-family: 'Noto Sans Bengali', sans-serif;
  font-size: 35px;
  font-weight: 700;
  color: var(--header-text-hover);
  line-height: 1.2;
  margin: 0;
  transition: color 0.3s ease;
}

.party-name-en {
  font-family: Georgia, serif;
  font-size: 10px;
  color: var(--header-gold-muted);
  letter-spacing: 2px;
  margin: 3px 0 0;
  transition: color 0.3s ease;
}

/* ─── Symbol ─── */
.symbol-zone {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

.header-actions {
  display: flex;
  justify-content: center;
  margin-bottom: 4px;
}

.theme-toggle {
  background: var(--theme-toggle-bg);
  border: 1px solid var(--theme-toggle-border);
  border-radius: 6px;
  padding: 3px 8px;
  cursor: pointer;
  font-size: 14px;
  line-height: 1;
  transition: background 0.2s ease, border-color 0.2s ease;
}
.theme-toggle:hover {
  background: var(--header-gold-faint);
  border-color: var(--header-gold);
}

.symbol-box {
  width: 56px;
  height: 56px;
  border: 2px solid #006B3F;
  border-radius: 8px;
  background: var(--symbol-bg);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 16px var(--symbol-shadow);
  transition: background 0.3s ease, box-shadow 0.3s ease;
}

.symbol-label {
  font-family: Georgia, serif;
  font-size: 9px;
  color: var(--header-gold-dim);
  letter-spacing: 1px;
  transition: color 0.3s ease;
}

/* ─── Nav Bar ─── */
.nav-bar {
  background: var(--header-bg-nav);
  border-bottom: 1px solid var(--header-border);
  transition: background 0.3s ease, border-color 0.3s ease;
}

.nav-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 44px;
}

.nav-links { display: flex; align-items: center; }

.nav-link {
  color: var(--header-text);
  text-decoration: none;
  font-family: 'Noto Sans Bengali', sans-serif;
  font-size: 14px;
  font-weight: 600;
  padding: 0 16px;
  height: 44px;
  display: flex;
  align-items: center;
  position: relative;
  transition: color 0.2s;
}

.nav-link::after {
  content: '';
  position: absolute;
  bottom: 0; left: 50%;
  transform: translateX(-50%);
  width: 0; height: 2px;
  background: #C8102E;
  transition: width 0.3s ease;
}

.nav-link:hover { color: var(--header-text-hover); }
.nav-link:hover::after { width: 60%; }
.nav-link.router-link-active { color: var(--header-gold); }
.nav-link.router-link-active::after { width: 60%; background: var(--header-gold); }

.nav-sep {
  width: 1px;
  height: 16px;
  background: var(--header-sep);
  flex-shrink: 0;
  transition: background 0.3s ease;
}

.nav-actions { display: flex; align-items: center; gap: 12px; }

.cta-button {
  font-family: 'Noto Sans Bengali', sans-serif;
  font-size: 12px; font-weight: 700;
  color: var(--header-gold);
  background: transparent;
  border: 1px solid var(--header-gold-dim);
  padding: 6px 16px; border-radius: 4px;
  cursor: pointer;
  transition: all 0.25s;
}
.cta-button:hover {
  background: var(--header-gold-faint);
  border-color: var(--header-gold);
  color: var(--header-text-hover);
}

.symbol-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 4px;
}

/* ─── Hamburger ─── */
.mobile-toggle { display: none; background: none; border: none; cursor: pointer; padding: 8px; }

.hamburger { display: block; width: 24px; height: 2px; background: var(--header-text-hover); position: relative; transition: all 0.3s ease; }
.hamburger::before, .hamburger::after { content: ''; position: absolute; width: 24px; height: 2px; background: var(--header-text-hover); transition: all 0.3s ease; }
.hamburger::before { top: -6px; }
.hamburger::after  { bottom: -6px; }
.hamburger.active { background: transparent; }
.hamburger.active::before { top: 0; transform: rotate(45deg); }
.hamburger.active::after  { bottom: 0; transform: rotate(-45deg); }

/* ─── Mobile Nav ─── */
.mobile-nav {
  display: flex;
  flex-direction: column;
  background: var(--header-bg-mobile);
  border-top: 1px solid rgba(200, 16, 46, 0.3);
  padding: 8px 0 16px;
  transition: background 0.3s ease;
}

.mobile-link {
  color: var(--header-text);
  text-decoration: none;
  font-family: 'Noto Sans Bengali', sans-serif;
  font-size: 15px;
  font-weight: 600;
  padding: 12px 24px;
  transition: all 0.2s;
  border-left: 3px solid transparent;
}
.mobile-link:hover, .mobile-link.router-link-active {
  color: var(--header-gold);
  background: var(--mobile-link-hover-bg);
  border-left-color: #C8102E;
}

.mobile-cta {
  font-family: 'Noto Sans Bengali', sans-serif;
  font-size: 14px; font-weight: 700;
  color: #fff;
  background: #C8102E;
  border: none;
  padding: 12px 24px;
  margin: 12px 24px 0;
  border-radius: 6px;
  cursor: pointer;
}
.mobile-cta:hover { background: #a00d25; }

/* ─── Transitions ─── */
.slide-down-enter-active, .slide-down-leave-active { transition: all 0.3s ease; }
.slide-down-enter-from, .slide-down-leave-to { opacity: 0; transform: translateY(-8px); }

/* ─── Responsive ─── */
@media (max-width: 900px) { .nav-link { padding: 0 10px; font-size: 12px; } }

@media (max-width: 768px) {
  .nav-links { display: none; }
  .mobile-toggle { display: block; }
  .cta-button { display: none; }
  .logo-circle, .symbol-box { width: 48px; height: 48px; }
  .bismillah-text { font-size: 14px; }
  .quran-row { flex-direction: column; gap: 4px; }
  .quran-divider { display: none; }
  .quran-meaning { font-size: 9px; }
}

@media (max-width: 480px) {
  .header-inner { padding: 8px 0; }
  .party-name-bn { font-size: 15px; }
  .logo-circle, .symbol-box { width: 42px; height: 42px; }
  .symbol-label { display: none; }
}
</style>